import React, {Fragment} from "react";
import ModalBase from "./ModalBase";
import Icon, {ilsFileJPG, ilsFilePDF} from "../Icon";
import '../../../assets/sass/components/modals/download-report-modal.scss';
import ReportFile from "../report/ReportFile";
import ReactDOM from 'react-dom';
import DocService from "../export/DocService";

const DownloadButton = (props) => {
    const getIcon = (type) => ({pdf: ilsFilePDF, jpg: ilsFileJPG}[type]);

    const {type, onClick} = props;
    const text = 'Download As';

    const icon = getIcon(type);

    return (
        <div className="download-button" onClick={onClick}>
            <Icon svg={icon}/>
            <div className="text">
                {text}
                <span className="text-uppercase"> {type} </span>
            </div>
        </div>
    );
};

/**
 * Download report modal.
 */
class DownloadReportModal extends ModalBase {
    /**
     * Renders modal content within the body of the modal.
     * @returns {React.ReactNode} The modal content.
     */

    renderBody = () => {
        // const {downloadText} = this.props;
        const downloadText = 'Select the format of report you want to download';
        return (
            <Fragment>
                <div className="theme--default" id="export-file"><ReportFile ref="report"/></div>

                <div className="download-text"> {downloadText} </div>
                <div className="d-flex">
                    <DownloadReportModal.Downloadbutton type={"pdf"} onClick={() => this.downloadPDFFile()}/>
                    <DownloadReportModal.Downloadbutton type={"jpg"} onClick={() => this.downloadPNGFile()}/>
                </div>
            </Fragment>
        );
    };

    renderFooter = () => undefined;


    downloadPDFFile = (event) => {
        DocService.exportPdf(this.reportNode(), this.exportedFileName());
    };

    downloadPNGFile = (event) => {
        DocService.exportJpg(this.reportNode(), this.exportedFileName());
    };


    reportNode = () => ReactDOM.findDOMNode(this.reportRef());
    reportRef = () => this.refs.report;
    exportedFileName = () => 'Scouting Report';

    static defaultProps = {
        headerTitle: "Download Report"
    };

    /**
     * Returns default size of modal.
     * @returns {string} The modal size.
     */
    defaultSize = () => "sm";

    modalClassname = () => "download-report-modal";
}

DownloadReportModal.Downloadbutton = DownloadButton;
DownloadReportModal.Name = "DownloadReportModal";


export default DownloadReportModal;
